var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"shaped":"","outlined":"","dismissible":"","transition":"scale-transition","type":_vm.alertType,"value":_vm.alert}},[_vm._v(" "+_vm._s(_vm.alertText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }